// extracted by mini-css-extract-plugin
module.exports = {"itemList":"CartItemsChangedModal_itemList__V9CIL","iconBack":"CartItemsChangedModal_iconBack__22hym","title":"CartItemsChangedModal_title__13JjP"};